import { Fragment } from "core/components/FragmentProvider";
import ProgramOverview from "../overview/ProgramOverview";
import ICourseFragmentProps from "./ICourseFragmentProps";

/**
 * ItemType-specific display
 */
const fragments: Record<string, Fragment<ICourseFragmentProps>> = {

	"base:program": {
		name: 'Program',
		component: ProgramOverview
	}

};

export default fragments;



// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/course/itemTypeOverviewFragments.tsx